type Props = {
  brand: string;
  last4: string;
}

// Map of Stripe card brands to their display names
const STRIPE_CARD_BRAND_DISPLAY: Record<string, string> = {
  visa: 'Visa',
  mastercard: 'Mastercard',
  amex: 'American Express',
  discover: 'Discover',
  diners: 'Diners Club',
  jcb: 'JCB',
  unionpay: 'UnionPay',
  unknown: 'Card'
}

const formatCardBrand = (brand: string): string => {
  return STRIPE_CARD_BRAND_DISPLAY[brand] ?? brand
}

export default function CardPaymentDetails ({ brand, last4 }: Props) {
  return (
    <div className='flex flex-row items-center gap-2'>
      <span>{formatCardBrand(brand)} ending in {last4}</span>
    </div>
  )
}
